import type { AxiosInstance, CreateAxiosDefaults } from 'axios'
import { createAxiosInstance } from '@/utilities/createAxiosInstance.ts'
import { useAuthStore } from '@/store/auth'

export class BaseService {
  protected instance: AxiosInstance

  constructor(config: CreateAxiosDefaults = {}) {
    this.instance = createAxiosInstance(config)
    this.setupAuthInterceptor()
  }

  setupAuthInterceptor() {
    this.instance.interceptors.request.use(
      async (config) => {
        try {
          const token = await useAuthStore().acquireToken()
          config.headers = config.headers || {}
          config.headers.Authorization = `Bearer ${token}`
        } catch (error) {
          console.warn(error)
        }
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )
  }
}
